export const manifest = {
  screens: {
    scr_jmj4uf: { name: "Accueil", route: "/", position: {"x":160,"y":220} },
    scr_bdkhly: { name: "À propos de Nous", route: "/a-propos", position: {"x":1560,"y":220} },
    scr_ayqvfo: { name: "Alimentation", route: "/alimentation", position: {"x":160,"y":2200} },
    scr_avdde2: { name: "Boisson", route: "/boisson", position: {"x":1560,"y":2200} },
    scr_8a37n1: { name: "Maison et Décoration", route: "/maison", position: {"x":2960,"y":2200} },
    scr_atolri: { name: "Electronique", route: "/electronique", position: {"x":4360,"y":2200} },
  },
  sections: {
    sec_ayeiok: { name: "Main Navigation", x: 0, y: 0, width: 2920, height: 1180 },
    sec_dm8th3: { name: "Product Categories", x: 0, y: 1980, width: 5720, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_ayeiok", children: [
      { kind: "screen", id: "scr_jmj4uf" },
      { kind: "screen", id: "scr_bdkhly" },
    ] },
    { kind: "section", id: "sec_dm8th3", children: [
      { kind: "screen", id: "scr_ayqvfo" },
      { kind: "screen", id: "scr_avdde2" },
      { kind: "screen", id: "scr_8a37n1" },
      { kind: "screen", id: "scr_atolri" },
    ] },
  ],
}
